type Cleanup = () => void

export function createInterval(handler: () => void, ms: number): Cleanup {
  if (typeof window === 'undefined') return () => {}
  const id = window.setInterval(handler, ms)
  return () => window.clearInterval(id)
}
